<template>
  <div class="">
    <el-container style="background-color: #f8f8f8;">
        <el-aside width="300px" style="background-color: #fff;margin: 20px 0 20px 20px;">
        <div class="version-selector">
          <span class="version-label">版本:</span>
          <el-select v-model="selectedVersion" placeholder="">
            <el-option
              v-for="item in versions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div >
          <el-menu
            :default-openeds="propList"
            class="el-menu-vertical-demo"
            style="padding: 0;"
            :unique-opened="true"
            @select="(key, keyPath) =>handleSelect(key, keyPath,selectedVersion)"
            @open="handleOpen"
            @close="handleClose">
            <el-submenu v-for="(item, index) in menuItems[selectedVersion]" :key="index" :index="`${index+1}`">
              <template slot="title">
                <span>{{Object.keys(item)[0]}}</span>
              </template>
              <el-menu-item-group v-for="(itemGroup, groupIndex) in item[Object.keys(item)[0]]" :key="groupIndex">
                <el-menu-item :index="`${index + 1}-${groupIndex}`">{{ itemGroup.title }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: "developmentDocking",
  data() {
    return {
      searchQuery: "",
      selectedVersion: 'V1.0',
      versions: [
        // { value: 'next', label: 'Next', tag: '' },
        // { value: '3.9', label: '3.9', tag: 'LATEST' },
        // { value: '3.8', label: '3.8', tag: '' },
        // { value: '3.7', label: '3.7', tag: '' },
        // { value: '3.6', label: '3.6', tag: '' },
        { value: 'V1.0', label: 'V1.0', tag: '' },

        { value: 'oldSystem', label: '老系统（兼容版本）', tag: '' },
      ],
      code: `{
        "shipment": {
          "service": "B2B",
          "store_id": "",
          "client_reference": "",
          "parcel_count": 2,
          "export_scc": 0,
          "import_scc": 0,
          "attrs": []
        }
      }`,
      menuItems: {
        
        "V1.0": [
          {
            "账户模块": [
              { title: '账户验证', index: '1' },
            ]
          },
          {
            "订单模块": [
              { title: '创建订单', index: '1' },
              { title: '根据订单号获取订单详情', index: '3' },
              { title: '获取渠道信息', index: '4' },
              { title: 'VAT号带搜索条件下拉', index: '9' },
              // { title: '获取交货仓库信息', index: '8' },
              { title: '获取FBA仓库编码', index: '5' },
              { title: '获取订单轨迹', index: '6' },
              // { title: '获取第三方海外信息', index: '7' },
              { title: '取消订单', index: '2' },
              // { title: '系统状态', index: '2' },
              // { title: '配置选项', index: '3' },
              // { title: '用户管理', index: '4' },
              // { title: '日志', index: '5' }
            ]
          },
        
         
          // {
          //   "小妹妹": [
          //     { title: '嘿嘿嘿', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // }
        ],
        "oldSystem": [
          {
            "运单模块": [
              { title: '创建运单', index: '1' },
              // { title: '系统状态', index: '2' },
              // { title: '配置选项', index: '3' },
              // { title: '用户管理', index: '4' },
              // { title: '日志', index: '5' }
            ]
          },
        
          // {
          //   "hhh": [
          //     { title: '来玩呀', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // },
          // {
          //   "小妹妹": [
          //     { title: '嘿嘿嘿', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // }
        ],
        // "3.5": [
        //   {
        //     "asa": [
        //       { title: '概览', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   },
        //   {
        //     "hhh": [
        //       { title: '来玩呀', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   },
        //   {
        //     "小妹妹": [
        //       { title: '嘿嘿嘿', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   }
        // ]
      }
    };
  },
  beforeRouteLeave(to, from, next) {
      // console.log('211111111',from)
    if (from.path === '/developmentDocking/main') {
      window.location.href = to.fullPath;
    } else {
      next(); 
    }
  },
  mounted() {
    console.log(this.selectedVersion,'this.selectedVersion')
    this.$router.push({ name: 'mainComponents', query: { api: '1-0',selectedVersion:this.selectedVersion } });
  },
  computed: {
    codeLines() {
      // 将代码按行分割成数组
      return this.code.split('\n');
    },
    propList() {
      return this.menuItems[this.selectedVersion].map((_, index) => `${index + 1}`);
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      //  console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //  console.log(key, keyPath);
    },
    handleSelect(key, keyPath,selectType) {
      console.log(key, keyPath,selectType, 'select');
      this.totalIndex = keyPath[0];
      this.$router.push({ name: 'mainComponents', query: { api: key,selectedVersion:selectType } });
    },
    filteredMenuItems(val) {
      this.propList = [];
      if (val === "") {
        return this.menuItems; // 如果没有搜索查询，返回全部
      }
      const searchLower = `${val}`;
      const append = this.menuItems.map((item, index) => {
        const key = Object.keys(this.menuItems[index])[0];
        const eleIndex = item[key].findIndex(element => searchLower === element.title.toLowerCase());
        if (eleIndex !== -1) {
          return { groupIndex: index, itemIndex: eleIndex, item: item[key][eleIndex] };
        }
      });
      const appendData = append.filter(x => x !== undefined);
      const index = `${appendData[0].groupIndex + 1}`;
      this.propList.push(index);
    }
  }
};
</script>
<style src="./index.css" scoped></style>
